module.exports = __webpack_public_path__ + "img/gh.107a1c6d.png";